export const emailHistoryEn = {
  DEBTOR_REMITTANCE: 'Debtor Remittance',
  NOA: 'NOA',
  BILLING: 'Billing',
  BROKER_REMITTANCE: 'Broker Remittance',
  VENDOR_REMITTANCE: 'Vendor Remittance',
  STATEMENT: 'Statement',
  UPDATE_RELATIONSHIP_REQUEST: 'Update Relationship Request',
  UPDATE_DEBTOR_REQUEST: 'Update Debtor Request',
  INVOICE_DOCUMENT_EXPORT: 'Invoice Document Export',
  SEND_DATE: 'Send Date',
  SEND_TYPE: 'Send Type',
  EMAIL_HISTORY: 'Email History',
  EMAIL_HISTORY_DETAIL: 'Email History Detail',
  SENT_BY_USER: 'Sent by user',
  SENT: 'Sent',
  SUBMITTED: 'Submitted',
  OPENED: 'Opened',
  CLICKED: 'Clicked',
  FAILED: 'Failed',
  SYSTEM: 'System',
  NOT_HISTORY_ASSOCIATED: 'The mail currently has no history associated with it.',
  //BEGIN MICHAEL
  SCHEDULE: 'Schedule',
  SCHEDULED: 'Scheduled',
  //END MICHAEL
}

export const emailHistoryEs: typeof emailHistoryEn = {
  DEBTOR_REMITTANCE: 'Remesa del deudor',
  NOA: 'NOA',
  BILLING: 'Facturación',
  BROKER_REMITTANCE: 'Remesa del corredor',
  VENDOR_REMITTANCE: 'Remesa del proveedor',
  STATEMENT: 'Declaración',
  UPDATE_RELATIONSHIP_REQUEST: 'Solicitud de actualización de relación',
  UPDATE_DEBTOR_REQUEST: 'Solicitud de actualización del deudor',
  INVOICE_DOCUMENT_EXPORT: 'Exportación de documentos de factura',
  SEND_DATE: 'Fecha de envío',
  SEND_TYPE: 'Tipo de envío',
  EMAIL_HISTORY: 'Historial de correo electrónico',
  EMAIL_HISTORY_DETAIL: 'Detalle del historial de correo',
  SENT_BY_USER: 'Enviado por el usuario',
  SENT: 'Enviado',
  SUBMITTED: 'Presentado',
  OPENED: 'Abierto',
  CLICKED: 'Hecho clic',
  FAILED: 'Fallido',
  SYSTEM: 'Sistema',
  NOT_HISTORY_ASSOCIATED: 'El correo actualmente no tiene un historial asociado.',
  //BEGIN MICHAEL
  SCHEDULE: 'Programar',
  SCHEDULED: 'Programado',
  //END MICHAEL
}
